<template lang="html">
  <div>
    <Breadcrumb class="breadcrumb" separator="＞">
        当前位置：
        <BreadcrumbItem :to="{ name:'NewsList' }">首页</BreadcrumbItem>
        <BreadcrumbItem :to="{ name: 'CompanyDetail', params: {uid: detail.entity_uid} }">{{detail.short_name}}</BreadcrumbItem>
        <BreadcrumbItem>{{detail.name}}</BreadcrumbItem>
    </Breadcrumb>
    <Layout class="layContent">
      <Content class="content listSider">
        <div class="module-left">
          <div class="layout-c-center">
            <div class="detail-avatar">
              <img v-if="detail.logo_url" :src="detail.logo_url | logo_show" />
              <Avatar :class="{ avatar: true }" v-else>{{ detail.name | firstname }}</Avatar>
            </div>
            <span class="detail-name">{{detail.name}}</span>
            <span class="detail-title" v-if="detail.title">{{detail.short_name}}{{detail.title}}</span>
          </div>
          <div class="p-info">
            <div><i class="iconfont-sm icon">&#xe63a;</i>{{detail.hometown_province | pc(detail.hometown_city)}}</div>
            <div><i class="iconfont-sm icon">&#xe635;</i>{{detail.tel | tel}}</div>
            <div><i class="iconfont-sm icon">&#xe638;</i>{{detail.email | empty('暂无邮箱')}}</div>
            <div><i class="iconfont-sm icon">&#xe637;</i>{{detail.birthday_year | empty('暂无出生年')}}</div>
            <div><i class="iconfont-sm icon">&#xe631;</i>{{detail.is_returnee | isno('海归','非海归')}}</div>
            <div><i class="iconfont-sm icon">&#xe639;</i>{{detail.highest_edu | deal('highest_edu')}}</div>
            <!-- <div>
              <i class="iconfont-sm" style="color:#0c68ab">&#xe640;</i>
              <i class="iconfont-sm" style="color:#00adef">&#xe643;</i>
              <i class="iconfont-sm" style="color:#2ec76a">&#xe641;</i>
              <i class="iconfont-sm" style="color:#ff582a">&#xe642;</i>
            </div> -->
          </div>
          <Divider class="dashed" dashed />
          <div class="summary">
            <div>
              <div>人物领域</div>
              <div class="tag">
                <span v-if="detail.nxfly.length == 0">暂无领域</span>
                <Tag>123</Tag>
              </div>
            </div>
            <div>
              <div>名片</div>
              <div>
                <span>暂未开发查询</span>
              </div>
            </div>
            <div>
              <div>人物简介</div>
              <div>
                {{detail.desc | empty('暂无')}}
              </div>
            </div>
          </div>
        </div>
        <div class="module-right">
          <div class="tab-item-2">
            <div>
              <!-- <Divider class="divider" orientation="left">投资项目</Divider> -->
              <div class="divider_line">
                <span>投资项目</span>
              </div>
            </div>
            <div class="list_div">
              <Table class="table-position" :columns="event_columns" :data="invest_event"></Table>
            </div>
            <div>
              <!-- <Divider class="divider" orientation="left">任职历史</Divider> -->
              <div class="divider_line">
                <span>任职历史</span>
              </div>
            </div>
            <div class="list_div">
              <Table class="table-position" :columns="work_columns" :data="work_his"></Table>
            </div>
            <div>
              <!-- <Divider class="divider" orientation="left">教育经历</Divider> -->
              <div class="divider_line">
                <span>教育经历</span>
              </div>
            </div>
            <div class="list_div">
              <Table class="table-position" :columns="edu_columns" :data="edu_his"></Table>
            </div>
          </div>
        </div>

        <Spin fix v-if="spinShow">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
      </Content>
    </layout>
  </div>
</template>

<script>
import { peoDetail } from '../../service'
import filter from 'js/filter'
export default {
  data() {
    return {
      spinShow: true,
      params: {
        uid: this.$route.params.uid
      },
      detail: {},
      edu_his: [],
      edu_columns: [
        { title: '学校', key: 'school', render:(h, params) => { return h('span', filter.empty(params.row.school))} },
        { title: '专业', key: 'major', render:(h, params) => { return h('span', filter.empty(params.row.major))}},
        { title: '学历', key: 'edu', render:(h, params) => { return h('span', filter.deal(params.row.edu, 'highest_edu'))} },
        { title: '学习时间',width: 250, key: 'time', render:(h, params) => { return h('span', filter.se(params.row.start_time, params.row.end_time))}}
      ],
      invest_event: [],
      event_columns: [
        { title: '项目名称', key: 'short_name',render:(h, params) => {
            return h('a', {on: {click: () => {this.goDetail(params.row.comp_uid, '0')}}}, params.row.entity_name)
          }
        },
        { title: '轮次', key: 'round_id',render:(h, params) => { return h('span', filter.deal(params.row.round_id,'round'))}},
        { title: '金额', key: 'amount', render:(h, params) => { return h('span', filter.amountPrecise(params.row.amount, params.row.unit_id, '1'))}},
        { title: '事件时间', key: 'date', render:(h, params) => { return h('span', filter.timeTrans(params.row.event_time))}}
      ],
      work_his: [],
      work_columns: [
        { title: '任职单位', key: 'name',render:(h, params) => {
            if(params.row.entity_name != ''){
              return h('a', {on: {click: () => {this.goDetail(params.row.entity_uid, params.row.entity_type)}}}, params.row.entity_name)
            }else{
              return h('span', params.row.dw_name)
            }
          }
        },
        { title: '创始人', key: 'lead', width: 80,render:(h, params) => { return h('span', filter.isno(params.row.founder))}},
        { title: '当前职务', key: 'title', render:(h, params) => { return h('span', filter.empty(params.row.title))}},
        { title: '任职时间', key: 'time', render:(h, params) => { return h('span', filter.se(params.row.start_time, params.row.end_time))}}
      ]
    }
  },
  methods: {
    async getDetail() {
      let res = await peoDetail(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'detail', res.baseinfo)
        this.$set(this.$data, 'edu_his', res.edu_his)
        this.$set(this.$data, 'work_his', res.work_his)
        this.$set(this.$data, 'invest_event', res.event)
      } else {
        this.$Message.error(res.msg)
      }
      this.spinShow = false
    },
    goDetail(uid, type) {
      if (type == '1') {
        this.$router.push({ name: 'OrgDetail', params: {uid: uid} })
      } else if(type == '2'){
        this.$router.push({name: 'PeoDetail', params: {uid: uid}})
      } else {
        this.$router.push({ name: 'CompanyDetail', params: {uid: uid} })
      }
    }
  },
  created() {
    this.getDetail()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
// $size = 16px
$width = 316px
// divAdd()
//   margin-top: 18px
.content
  margin: 0 20px 20px 20px
  background: white
  position: relative
  display: flex
.listContent
  margin: 0
  box-shadow: none
.divider_line
  margin: 42px 0 38px 0
.module
  &-left
    flex: 0 0 316px
    padding: 60px 40px 40px 40px
    border-right: 1px solid
    commonBgColor(#2A2F42, #FFFFFF)
    commonBorderColor(#2A2F42, #E9E9E9)
  &-right
    flex: auto
    border-left: 1px $borderLine solid
    padding: 0 32px 32px 32px
    commonBgColor(#1F2330, #FFFFFF)
.p-info
  // width: 50%
  font-size: 14px
  div
    display: flex
    margin-top: 18px
    commonColor(#E9E9EB, #333333)
  i
    margin-right: 10px
    font-size: 16px
$detail_avatar = 70px
.detail-avatar
  width: $detail_avatar
  height: $detail_avatar
  // line-height: $avatar
  margin-right: 0
  border-radius: 50%
  overflow: hidden
  font-size: 16px
  img
    max-width: 100%
    max-height: 100%
    vertical-align: middle
    margin-right: 0
  .avatar
    background: #568BAD
  .ivu-avatar
    width: $detail_avatar
    height: $detail_avatar
  .ivu-avatar >>> .ivu-avatar-string
    line-height: $detail_avatar
    font-size: 24px
    left: calc(50% - 12px) !important
.detail-name
  margin: 20px 0 16px 0
  commonColor(#E9E9EB, #333333)
  font-weight: bold
  font-size: 18px
.detail-title
  margin-bottom: 18px
  commonColor(#797B83, #999999)
  font-size: 14px
.icon
  margin-right: 16px
  color: #797B83

.summary
  font-size: 14px
  >div
    >div:nth-child(1)
      border-left: 2px #107FEF solid
      padding-left: 8px
      commonColor(#E9E9EB, #333333)
    .tag >>> .ivu-tag
      cursor: default
    >div:nth-child(2)
      commonColor(#BCBDC1, #999999)
      line-height: 22px
      padding-left: 8px
      margin: 8px 0 18px 0
.breadcrumb
  font-size: 12px
  padding: 15px 0 0 24px
  margin-bottom: 10px
  >>> span
        a
          color: #999999
        span
          margin: 0 3px
        span.ivu-breadcrumb-item-link
          color: rgba(250, 122, 80, 1)
.table-position
  margin-left: 18px
.dashed
  border-top: 1px dashed #40444F
</style>
